// Evina DCBprotect kit: the service fetches it with the API key (ti = this page's ext_ref) and
// returns it base64; we put it in the page once and (re)arm it on the protected button.
// te = the button whose tap Evina protects: JOIN on HE, CONFIRM (submit PIN) on the PIN flow, both
// marked evina-protect. Not GET PIN: it carries the cptpl_subscribe compliance marker while the number
// page shows, but te must match only CONFIRM on that flow (Evina, 15 Oct 2026).
export const EVINA_TARGET = '.evina-protect'

const GATEWAY_LOAD_TIMEOUT_MS = 8000
let injected = false

function decode(base64) {
  try {
    return atob(base64)
  } catch {
    return ''
  }
}

// Evina returns either raw JS or <script> tags (inline or src); scripts set via innerHTML
// never execute, so each one is recreated. Appended to <body>, as Evina's Telkom snippet does.
function appendScripts(markup) {
  if (!/^\s*<script/i.test(markup)) {
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.text = markup
    document.body.appendChild(script)
    return
  }
  const parsed = new DOMParser().parseFromString(markup, 'text/html')
  parsed.querySelectorAll('script').forEach((node) => {
    const script = document.createElement('script')
    for (const attribute of node.attributes) script.setAttribute(attribute.name, attribute.value)
    if (!node.getAttribute('src')) script.text = node.textContent
    document.body.appendChild(script)
  })
}

// Evina's staging switch: ?cp=1 on the page asks the service to request the kit with cp=1, so
// ComplianceProtect runs for that visit only (Evina, 24 Sep 2026).
export function complianceProtectTest() {
  return new URLSearchParams(window.location.search).get('cp') === '1'
}

export async function injectEvinaScript(base64Script) {
  if (injected) {
    rearmEvina()
    return { ok: true, reused: true }
  }
  const markup = decode(base64Script)
  if (!markup) return { ok: false }

  const ready = new Promise((resolve) => {
    document.addEventListener('gateway-load', () => resolve(true), { once: true })
    setTimeout(() => resolve(false), GATEWAY_LOAD_TIMEOUT_MS)
  })

  appendScripts(markup)
  injected = true
  document.dispatchEvent(new Event('DCBProtectRun'))
  return { ok: true, gatewayLoaded: await ready }
}

// The protected button is re-created when the step changes; ask the kit to bind again.
export function rearmEvina() {
  if (injected) document.dispatchEvent(new Event('DCBProtectRun'))
}
